module.exports = __webpack_public_path__ + "img/6.86038cb4.png";